<div class="header-row">
  <div class="header">Korisnici</div>
  <button (click)="createUser()" mat-flat-button color="primary" class="button">
    <mat-icon
      aria-hidden="false"
      aria-label=" logout icon"
      fontIcon="person_add"
    ></mat-icon>
    Novi korisnik
  </button>
</div>
<div class="table-container">
  <div class="mat-elevation-z2">
    <table mat-table [dataSource]="users">
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef>Ime</th>
        <td mat-cell *matCellDef="let user">{{ user.firstName }}</td>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef>Prezime</th>
        <td mat-cell *matCellDef="let user">{{ user.lastName }}</td>
      </ng-container>

      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef>Korisničko ime</th>
        <td mat-cell *matCellDef="let user">{{ user.userName }}</td>
      </ng-container>

      <ng-container matColumnDef="orgName">
        <th mat-header-cell *matHeaderCellDef>Organizacija</th>
        <td mat-cell *matCellDef="let user">{{ user.orgName }}</td>
      </ng-container>

      <ng-container matColumnDef="typeUcode">
        <th mat-header-cell *matHeaderCellDef>Tip korisnika</th>
        <td mat-cell *matCellDef="let user">
          {{ getTypeName(user.typeUcode) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Akcije</th>
        <td mat-cell *matCellDef="let user">
          <button
            style="margin-right: 5px"
            mat-button
            mat-stroked-button
            color="accent"
            (click)="viewUser(user)"
            [ngStyle]="{
              padding: '0 16px',
              borderRadius: '8px',
              fontSize: '14px',
              letterSpacing: '0.8px',
              fontWeight: 'bold'
            }"
          >
            <mat-icon
              aria-hidden="false"
              aria-label=" logout icon"
              fontIcon="remove_red_eye"
            ></mat-icon>
            Detalji
          </button>
          <button
            *ngIf="user.typeUcode != 'APP_USER'"
            mat-button
            mat-stroked-button
            color="warn"
            (click)="deleteUser(user)"
            [ngStyle]="{
              padding: '0 16px',
              borderRadius: '8px',
              fontSize: '14px',
              letterSpacing: '0.8px',
              fontWeight: 'bold'
            }"
          >
            <mat-icon
              aria-hidden="false"
              aria-label=" logout icon"
              fontIcon="delete"
            ></mat-icon>
            Obriši
          </button>
        </td>
      </ng-container>

      <!-- Table rows -->
      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
        class="header-row-color"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        [ngClass]="{ 'highlighted-row': colored == row.userName }"
      ></tr>
    </table>
  </div>
</div>
